import block from './block.json';

export const cardCtaThemeAttributes = {
	minHeight: [221, 380],
	title: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.heading-2',
		textAlignment: 'center',
	},
	text: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.fresco-s',
		textAlignment: 'center',
	},
	backgroundColors: {
		grey: '@tokens.colors.neutral-200.value',
		pink: '@tokens.colors.brand-quaternary-base.value',
		black: '@tokens.colors.neutral-900.value',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const CardCtaThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: cardCtaThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
